import Select from "react-select";
const BasicSelectPlain = ({
  value,
  onChange,
  name = "",
  getOptionLabel = () => {},
  getOptionValue = () => {},
  data,
  dark = false,
}: any) => {
  const customStyles = {
    control: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: dark ? "transparent" : "#fff",
      border: "none",
      minHeight: "17.5px",
      borderColor: state.isFocused ? "#ddd" : provided.borderColor,
      "&:hover": {
        borderColor: state.isFocused ? "#aaa" : provided.borderColor,
      },
      outline: "none !important",
    }),
    singleValue: (base: any) => ({
      ...base,
      color: dark ? "#fff" : base.color,
    }),
    placeholder: (base: any) => ({
      ...base,
      color: dark ? "rgba(255,255,255,0.4)" : base.color,
    }),
    valueContainer: (base: any, state: any) => ({
      ...base,
      height: "17.5px",
      padding: "0 0px",
      borderColor: state.isFocused ? "#ddd" : base.borderColor,
      "&:hover": {
        borderColor: state.isFocused ? "#aaa" : base.borderColor,
      },
      outline: "none !important",
    }),
    input: (base: any, state: any) => ({
      ...base,
      margin: "0px",
      padding: "0px",
      color: dark ? "#fff" : base.color,
      borderColor: state.isFocused ? "#ddd" : base.borderColor,
      "&:hover": {
        borderColor: state.isFocused ? "#aaa" : base.borderColor,
      },
      outline: "none !important",
    }),
    indicatorsContainer: (base: any) => ({
      ...base,
      height: "17.5px",
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      color: state.isSelected ? "white" : "black",
      backgroundColor: state.isSelected ? "#888" : "white",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    container: (base: any) => ({
      ...base,
      width: "100%",
      minHeight: "10px",
    }),
  };
  return (
    <div
      className={
        dark
          ? "border-white/25 bg-white/10 outline-none flex flex-col border-[1px] py-1 h-auto rounded-[14px] w-full text-white px-3 focus-within:border-orange-400 transition-colors"
          : "border-[#302D6340]  outline-none flex flex-col border-[1px] py-1 h-auto rounded-[4px] w-full text-[#171717] px-2  focus:border-b-[#EE723A] focus:border-2"
      }
    >
      <label className={dark ? "text-xs mb-1 text-white/55" : "text-xs mb-1 text-slate-500"}>{name}</label>
      <Select
        value={value}
        options={data}
        isSearchable
        styles={customStyles}
        onChange={onChange}
        getOptionLabel={getOptionLabel}
        getOptionValue={getOptionValue}
      />
    </div>
  );
};
export default BasicSelectPlain;
